var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"white"},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-row',_vm._l((_vm.newsStore.latest),function(item){return _c('news-item',{key:item.id,attrs:{"data":item}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }